<template>
  <div class="header">
    <div class="header_top">
      <!-- <div @click="personalCenter"> -->
      <div>
        <img class="Logo_style" src="../../assets/img/logo.png" alt="" />
      </div>
      <!-- 导航栏 -->
      <ul class="navigation">
        <!-- @click="item.fun(item.id)" -->
        <li v-for="(item, index) in topNav" :key="index">
          <p
            class="cursor"
            @click="ClickOnTheEvent(item.id)"
            name="jumpitem"
            :class="item.clicks == true ? 'clickStyle' : ''"
          >
            {{ item.name }}
          </p>
        </li>
      </ul>
      <ul class="login" v-if="token != ''">
        <!-- 判断用户信息是否存在 -->
        <span v-if="userInfo && userInfo.ID">
          <HeaderPortrait
            @personalCenter="personalCenter"
            :msg="newInfo"
            :url="global.photoUrl + userInfo.Location"
            @CancelMsg="CancelMsg"
          ></HeaderPortrait>
        </span>
        <span v-else>
          <el-button class="log" plain @click="login">管理员登录</el-button>
        </span>

        <!-- 判断 -->
        <span v-if="userInfo && userInfo.IsAuthenticated"> </span>
      </ul>
    </div>
    <slot></slot>
    <!-- 登录认证  -->
    <!-- 认证弹窗 -->
    <CertificationDialog
      :certificationInfo="certificationInfo"
      :userData="userData"
      :visible.sync="certificationInfo.dialogVisible"
      @UserAuthentication="UserAuthentication"
    ></CertificationDialog>
    <!-- 登录弹窗 -->
    <LoginDialog
      v-on="$listeners"
      :loginsInfo="loginsInfo"
      :visible.sync="loginsInfo.dialogVisible"
    ></LoginDialog>
    <!-- 注册弹窗 -->
    <Registered
      v-on="$listeners"
      :loginsInfo="registeredInfo"
      :visible.sync="registeredInfo.dialogVisible"
    ></Registered>
    <!-- 忘记密码 -->
    <ForgetPassword
      v-on="$listeners"
      @getPhone="getPhone"
      :loginsInfo="ForgetPassword"
      :visible.sync="ForgetPassword.dialogVisible"
    ></ForgetPassword>
    <!-- 重置密码 -->
    <ResetPassword
      v-on="$listeners"
      :loginsInfo="ResetPassword"
      :restPhone="restPhone"
      :visible.sync="ResetPassword.dialogVisible"
    ></ResetPassword>
  </div>
</template>

<script>
// 认证弹窗
import CertificationDialog from "../../components/Dialog/certification.vue";
// 登录弹窗
import LoginDialog from "../../components/Dialog/login.vue";
// 注册弹窗
import Registered from "../../components/Dialog/Registered.vue";
// 忘记密码弹窗
import ForgetPassword from "../../components/Dialog/ForgetPassword.vue";
// 重置密码弹窗
import ResetPassword from "../../components/Dialog/ResetPassword.vue";
// 头像部分
import HeaderPortrait from "../../views/front/frontHome/components/headerPortrait.vue";
// 返回顶部
import BlackTo from "@/components/BlackToTop/BlackTo.vue";
// 引入接口
import { UserAuthentication, GetVerificationCode } from "@/api/user.js";
import { CanNewMsgTip } from "@/api/public.js";
// 辅助函数
import { mapGetters } from "vuex";
export default {
  name: "Header",
  components: {
    CertificationDialog,
    LoginDialog,
    Registered,
    HeaderPortrait,
    BlackTo,
    ForgetPassword,
    ResetPassword
  },
  props: {
    topNav: {
      type: Array
    }
  },
  data() {
    return {
      token: "123",
      searchInfo: "",
      // 需要重置得手机号
      restPhone: ""
    };
  },
  computed: {
    ...mapGetters(["userInfo", "users"]),
    username: {
      get() {
        return this.userInfo.UserNickName.slice(0, 5);
      }
    },
    loginsInfo: {
      get() {
        return this.$store.state.users.loginsInfo;
      }
    },
    registeredInfo: {
      get() {
        return this.$store.state.users.registeredInfo;
      }
    },
    ForgetPassword: {
      get() {
        return this.$store.state.users.ForgetPassword;
      }
    },
    ResetPassword: {
      get() {
        return this.$store.state.users.ResetPassword;
      }
    },
    certificationInfo: {
      get() {
        return this.$store.state.users.certificationInfo;
      }
    },
    userData: {
      get() {
        return this.$store.state.users.userData;
      }
    },
    // 判断是否有新消息
    newInfo: {
      get() {
        return this.$store.state.users.userData.IsHaveNewMsg;
      },
      set(val) {
        this.$store.state.users.userData.IsHaveNewMsg = val;
      }
    }
  },
  created() {
    this.AccessToInformation();
  },
  mounted() {
    this.reset();
    // 定时器（设置时间3s）
    this.timer = setInterval(this.AccessToInformation, 10000);
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    getPhone(data) {
      console.log(data);
      this.restPhone = data;
    },
    // 定时 刷新，请求获取用户信息
    AccessToInformation() {
      if (this.$store.state.users.token) {
        // console.log("开启定时器");
        // 需要定时执行的代码;
        this.$store.dispatch("users/getUserData");
      }
    },
    // 回车搜索
    search() {
      if (this.searchInfo != "") {
        // 保存到 vuex
        console.log(this.searchInfo);
      }
      this.$store.commit("header/ADD_SEARCHINFO", this.searchInfo);
    },
    // 失去焦点
    LoseFocus() {
      this.searchInfo = "";
    },
    reset() {
      const title = this.$router.app._route.meta.title;
      if (!title) return;
      for (let item of this.topNav) {
        if (item.name == title) {
          item.clicks = true;
        } else {
          item.clicks = false;
        }
      }
    },
    // 登录
    login() {
      this.loginsInfo.dialogVisible = true;
    },
    // 认证
    certification() {
      if (this.$store.state.users.token) {
        this.certificationInfo.dialogVisible = true;
      } else {
        this.$message({
          message: "请先登录，在进行认证",
          type: "success"
        });
        this.loginsInfo.dialogVisible = true;
      }
    },
    // 认证 确认事件
    UserAuthentication(val) {
      console.log(val);
      UserAuthentication(val).then(async res => {
        if (res.Code === 0) {
          this.$message({
            message: "重新认证成功",
            type: "success"
          });
          await this.$store.dispatch("users/getUserData");
        }
      });
    },
    // 注册
    Registered() {
      this.registeredInfo.dialogVisible = true;
    },

    //  头部点击事件
    ClickOnTheEvent(data) {
      // console.log(data);
      if (data == 1) {
        this.$router.push("/Home");
      } else if (data == 2) {
        this.$router.push("/AllCourses");
      } else {
        this.$router.push("/IndustryBBS");
      }
      this.clickHeader(data);
    },
    // 转换,点击模块,就让哪个模块高亮
    clickHeader(id) {
      console.log(id);
      this.topNav.forEach(item => {
        if (item.id == id) {
          item.clicks = true;
        } else {
          item.clicks = false;
        }
      });
    },
    // 个人中心
    async personalCenter() {
      for (let item of this.topNav) {
        item.clicks = false;
      }
      // 如果没有新消息，就跳转到我的贴子
      if (!this.newInfo) {
        this.$router.push({
          name: "personalCenter",
          query: {
            id: 1
          }
        });
      } else {
        this.$router.push("/personalCenter");
      }
      this.newInfo = false;
    },
    // 点击取消消息
    async CancelMsg() {
      for (let item of this.topNav) {
        item.clicks = false;
      }
      // 如果没有新消息，就跳转到我的贴子
      if (!this.newInfo) {
        // this.$router.push({
        //   name: "personalCenter",
        //   query: {
        //     isMsg: this.newInfo
        //   }
        // });
        this.$router.push({
          name: "personalCenter",
          query: {
            id: 1
          }
        });
      } else {
        this.$router.push({
          name: "personalCenter",
          query: {
            id: 2
          }
        });
        // this.$router.push("/personalCenter");
      }
      this.newInfo = false;
    }
  }
};
</script>

<style lang="less" scoped>
.Logo_style {
  width: 200px;
  height: 27px;
}
// 设置头部样式
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
  background: #ffffff;
  box-shadow: 0px 3px 11px 1px rgba(0, 0, 0, 0.12);
  position: relative;
  top: 0px;
  left: 0px;
  z-index: 999;
  .header_top {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
// .header div {
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   // 扫码进小程序
//   .program {
//     position: relative;
//     width: 180px;
//     height: 46px;
//     background: #5690f1;
//     border-radius: 23px;
//     // margin-right: 40px;
//     p {
//       width: 97px;
//       // height: 16px;
//       font-size: 16px;
//       font-family: Microsoft YaHei;
//       font-weight: 400;
//       color: #ffffff;
//       margin: auto;
//       line-height: 46px;
//     }
//     img {
//       position: absolute;
//       width: 16px;
//       height: 15px;
//       top: 15px;
//       left: 20px;
//     }
//   }
// }
.navigation {
  list-style: none;
  display: flex;
  justify-content: space-around;
  padding-left: 200px;
  padding-right: 200px;
  // 导航栏 样式
  li {
    margin-left: 57px;
    color: #656665;
    :hover {
      color: #5690f1;
    }
  }
}

// 搜索框
.header /deep/ .search_input {
  width: 304px;
  padding-right: 136px;
}

.el-input--prefix /deep/ .el-input__inner {
  height: 46px;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 23px !important;
}
// 登录认证
.login {
  list-style: none;
  display: flex;
  margin-left: 53px;
  line-height: 48px;
  padding: 0px;
  .log {
    &:hover {
      color: #5690f1;
      cursor: pointer;
    }
  }
  .cert {
    &:hover {
      color: #5690f1;
      cursor: pointer;
    }
  }
}
// 点击样式
.clickStyle {
  color: #5690f1;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/layout_font/headers/headers.vue